import React from 'react';
import AnimatedSection from './AnimatedSection';
import './HeroSection.css';

const HeroSection = () => {
  const mainScreen = {
    id: 1,
    image: '/images/word-summer-main.jpg'
  };

  return (
    <section className="hero-section" id="hero">
      <div className="hero-content">
        <AnimatedSection direction="fade" className="hero-layout">
          <div className="hero-screen-wrapper">
            <div className="screen-card">
              <div className="phone-frame">
                <div 
                  className="phone-screen"
                  style={{
                    backgroundImage: `url(${mainScreen.image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundColor: '#000'
                  }}
                />
              </div>
            </div>
          </div>
          
          <div className="hero-text">
            <h1 className="hero-title">
              We are a <span className="title-accent">game development</span> company
            </h1>
            <p className="hero-description">
              BG5 LLC is UAE-based startup focused on creating high-quality mobile games & apps.
              We love what we do and aim to become the best.
            </p>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default HeroSection;

